module.exports = __webpack_public_path__ + "img/carburant.02e3f152.svg";